import type { RootContent } from 'hast';
import { SKIP, visit } from 'unist-util-visit';

import createNode from '../utils/create-node';

const subscribeForm = () => {
    return (tree: any) => {
        const subscribeFormNode = createNode({ id: 'subscribe-form-id', tagName: 'subscribe-form' });
        const paragraphCount = tree.children.filter(
            (e: any): e is RootContent & { tagName: string } => 'tagName' in e && e.tagName === 'p',
        ).length;
        const insertIndex = Math.floor(paragraphCount * (1 / 3));
        let nodeCount = 0;

        visit(tree, 'element', (node, index) => {
            if (index !== undefined && node.tagName === 'p' && ++nodeCount === insertIndex) {
                tree.children.splice(index + 1, 0, subscribeFormNode);

                return [SKIP];
            }
            return [];
        });
    };
};

export default subscribeForm;
